module.exports = __webpack_public_path__ + "img/2-3.aa3ae6b5.png";